import TortolaOffice from 'assets/contact/tortola_office.png';

import ContactOfficeCard from './contactOfficeCard/ContactOfficeCard';

const ContactOffice = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 sm:tw-items-start">
      <h2 className="tw-mb-7.5 tw-text-[30px] tw-font-bold tw-uppercase tw-text-white md:tw-text-[44px] xl:tw-text-5xl">
        Our offices
      </h2>
      <ContactOfficeCard
        officeImg={TortolaOffice}
        name="Reality NFT Ltd"
        address="Intershore Chambers, Road Town Tortola,"
        country="British Virgin Islands"
      />
    </div>
  );
};

export default ContactOffice;
